var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchDropdownChevronOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.909,
    cy: 10.957,
    fill: "#000000",
    rx: 10.909,
    ry: 10.957,
    transform: "translate(.182 .375)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 1.047,
    d: "M14.471 11.273c0 .101-.039.198-.107.269l-4.38 4.537a.356.356 0 0 1-.356.109.373.373 0 0 1-.264-.274.39.39 0 0 1 .105-.373l4.116-4.293-4.145-4.32a.392.392 0 0 1 .06-.47.354.354 0 0 1 .456-.041l4.403 4.588c.07.07.11.167.112.268z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchDropdownChevronOn);
export default __webpack_public_path__ + "static/media/search-dropdown-chevron-on.5421b1b58a398eae44dee0c72edc8273.svg";
export { ForwardRef as ReactComponent };